export const freightRateConstants = {
    FREIGHT_RATE_FETCHING: 'FREIGHT_RATE_FETCHING',
    FREIGHT_RATE_FETCHED: 'FREIGHT_RATE_FETCHED',
    GET_ALL_FREIGHT_RATES: 'GET_ALL_FREIGHT_RATES',
    GET_FREIGHT_RATES: 'GET_FREIGHT_RATES',
    GET_FREIGHT_RATE_BY_ID: 'GET_FREIGHT_RATE_BY_ID',
    UPDATE_FREIGHT_RATE: 'UPDATE_FREIGHT_RATE',
    SEARCH_FREIGHT_RATES: 'SEARCH_FREIGHT_RATES',
    GET_FREIGHT_RATES_CHARGE: 'GET_FREIGHT_RATES_CHARGE',
    GET_FREIGHT_RATES_ORIGIN: 'GET_FREIGHT_RATES_ORIGIN',
    GET_FREIGHT_RATES_CHARGE_ORIGIN: 'GET_FREIGHT_RATES_CHARGE_ORIGIN',
}